import { WebSocketLink } from '@apollo/client/link/ws';
import { getCustomHeaders } from 'services/apollo-client/links/auth-link';

const wsLink = new WebSocketLink({
  uri: process.env.REACT_APP_GRAPHQL_SUBSCRIPTIONS_URL as string,
  options: {
    reconnect: true,
    connectionParams: () => {
      return getCustomHeaders();
    },
  },
});

export default wsLink;
